import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CaminhaoResponse,
  GetCaminhaoParams,
  ICreateCaminhaoVinculoEmpresa,
  IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlacaResponse
} from './caminhao.model';
import { buildQueryParams } from 'src/app/core/utils/builder-query-params';

@Injectable({
  providedIn: 'root'
})
export class CaminhaoService {
  constructor(private http: HttpClient) {}

  public GetCaminhaoByAgendamento(idAgendamento?: number): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    let url = `${environment.baseURL}Caminhao/GetCaminhaoByAgendamento`;

    if (!invalid.includes(idAgendamento)) {
      url += `?idAgendamento=${idAgendamento}`;
    }

    return this.http.get<any>(url);
  }

  public CreateCaminhaoVinculoEmpresa(body: ICreateCaminhaoVinculoEmpresa) {
    return this.http.post<any>(
      `${environment.baseURL}Caminhao/CreateCaminhaoVinculoEmpresa`,
      body
    );
  }

  public GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca(
    FK_GATE_ENTR?: number | null,
    FK_AGND?: number | null,
    TX_PLCA_CAVA?: string | null
  ): Observable<IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlacaResponse> {
    const url = `${environment.baseURL}Caminhao/GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca`;
    let params: any = {};

    if (FK_GATE_ENTR) {
      params['FK_GATE_ENTR'] = FK_GATE_ENTR;
    }
    if (FK_AGND) {
      params['FK_AGND'] = FK_AGND;
    }
    if (TX_PLCA_CAVA) {
      params['TX_PLCA_CAVA'] = TX_PLCA_CAVA;
    }

    return this.http.get<any>(url, { params });
  }

    public GetLastVersionCaminhaoParams(
    params: GetCaminhaoParams
  ): Observable<CaminhaoResponse> {

    const httpParams = buildQueryParams(params);

    const url = `${environment.baseURL}Caminhao/GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca`;

    return this.http.get<CaminhaoResponse>(url, {
      params: httpParams
    });
  }
}
